import React, { useEffect, useState, useMemo } from "react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { PageShell, PageHero } from "@/components/layout/PageShell";
import { DistrictCard } from "@/components/common/DistrictCard";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { GMOAA } from "@/constants/testIds";

const Districts = () => {
  const { t } = useLang();
  const [districts, setDistricts] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => { api.districts().then(setDistricts); }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return districts;
    return districts.filter((d) => d.name_en.toLowerCase().includes(q) || d.name_gu.includes(query));
  }, [districts, query]);

  return (
    <PageShell>
      <PageHero title={t("districtsTitle")} subtitle={t("districtsSubtitle")} />
      <div className="gmoaa-container py-10">
        <div className="relative mb-6 max-w-md">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gmoaa-text-muted" />
          <Input
            data-testid="district-search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t("searchGr")}
            className="border-gmoaa-border-subtle bg-white pl-10"
          />
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((d) => <DistrictCard key={d.id} district={d} />)}
        </div>
        {filtered.length === 0 && <p className="py-10 text-center text-gmoaa-text-muted">{t("noResults")}</p>}
      </div>
    </PageShell>
  );
};

export default Districts;
